import Icon from '@/asset/Icon'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { FORMAT_ELEMENT_COMMAND } from 'lexical'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'

export default function AlignmentUIPlugin() {
  const [editor] = useLexicalComposerContext()
  return (
    <ButtonGroup className="me-2" aria-label="alignment-control-panel">
      <Button
        onClick={() => editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'left')}
        variant="outline-secondary"
      >
        <Icon type="leftAlign" />
      </Button>
      <Button
        onClick={() => editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'center')}
        variant="outline-secondary"
      >
        <Icon type="centerAlign" />
      </Button>
      <Button
        onClick={() => editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'right')}
        variant="outline-secondary"
      >
        <Icon type="rightAlign" />
      </Button>
    </ButtonGroup>
  )
}
